import { CommentFeed } from "src/components";
import { CommentFeedFragment } from "src/components/comments/CommentFeed.generated";
export function BudgetCommentsTab({ commentable }: { commentable: CommentFeedFragment }) {
  return <CommentFeed commentable={commentable} />;
}
